import React, {useEffect, useState} from "react";
import successPayment from "../../assets/img/successPayment/paiement-ok.png";
import cotillon from "../../assets/img/successPayment/cotillons.gif";
import {getApiBaseUrl} from "../../utils/baseUrl";
import {useStripe} from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import {createSouscription} from "../../actions/stripePayment";
// Modal qui affiche le message résultant d'un paiement stripe effectué par l'utilisateur qui retourne une url avec un clientSecret
// On peut voir que ce message est attribué (setStripeMessage) dans l'un des deux useEffect présent au début du composant et
// permettant de récupérer les informations d'une instance Stripe grâce au clientSecret

const StripePaymentModal = ({stripeMessage, setStripeMessage}) => {
// Renvoi une référence à l'instance stripe pour vérifier si un paiement a été intenter. Si oui, vérifier l'état de ce paiement
// https://stripe.com/docs/stripe-js/react#hook-usestripe
const stripe = useStripe();
// Animation success paiement
const [animation, setAnimation] = useState(true);

// Chargement de la réponse en cas de paiement en une fois
// Création d'une souscriptions en cas de paiment réussi
useEffect(() => {
if (!stripe) {
return;
}
// On recherche un clientSecret dans l'url
// Le clientSecret est une clé retournée par l'API Stripe lors d'un paiement
// Cette clé est retourné par Stripe dans les fichiers qui permettent de confirmer un paiement
// Plus de détail dans le sous-dossier "./Home/OfferModal/Stripe/Offer390/Checkout/CheckoutForm.js"
// "./Home/OfferModal/Stripe/Offer600/Checkout/CheckoutForm.js"
const clientSecret = new URLSearchParams(window.location.search).get(
"payment_intent_client_secret"
);

if (!clientSecret) {
return;
}
// Si une clé clientSecret existe dans l'url, cela signifie que l'utilisateur a réalisé un paiement
// Ici on veut récupérer les informations liées à ce paiement et savoir son statut pour déterminer
// s'il faut créer une souscriptions ou non
stripe.retrievePaymentIntent(clientSecret).then(({paymentIntent}) => {
switch (paymentIntent.status) {
// Création d'une souscriptions en cas de succès de paiement
case "succeeded": {
createSouscription();
window.localStorage.removeItem("promotionCode");
setTimeout(() => {
setAnimation(false);
}, 3000);
// On affiche un message en conséquence du statut
setStripeMessage("Paiement réussi, merci pour votre confiance !");
}
break;
case "processing":
setStripeMessage("Paiement en cs");
break;
case "requires_payment_method":
setStripeMessage("Votre paiement a échoué, réessayez");
break;
default:
setStripeMessage("Une erreur est survenue");
break;
}
});
}, [stripe]);

// Chargement de la réponse en cas de paiement en 3 fois
// Création d'une souscriptions en cas de paiment réussi
useEffect(() => {
if (!stripe) {
return;
}
// Ici on retrouve la même chose qu'au-dessus, mais concernant le paiement en 3 fois
// Détails : "./Home/OfferModal/Stripe/Offer600/Checkout/SetupForm.js"
const clientSecret = new URLSearchParams(window.location.search).get(
"setup_intent_client_secret"
);
const setupIntent = new URLSearchParams(window.location.search).get(
"setup_intent"
);

if (!clientSecret) {
return;
}

// Retrieve the SetupIntent
stripe.retrieveSetupIntent(clientSecret).then((res) => {
// Inspect the SetupIntent `status` to indicate the status of the payment
// to your customer.
//
// Some payment methods will [immediately succeed or fail][0] upon
// confirmation, while others will first enter a `processing` state.
//
// [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
switch (res.setupIntent.status) {
case "succeeded":
// En cas de succès création du paiement Stripe en trois mensualités grâce à l'API SubrcriptionSchedules de stripe
// cf. le fichier de l'API "./api/internal/subscriptionSchedulesSetupIntent.php" pour examiner ce qui se déroule
fetch(`${getApiBaseUrl()}/subscriptionSchedulesSetupIntent/`, {
method: "POST",
headers: {"Content-Type": "application/json"},
body: JSON.stringify({
// On passe l'id du customer Stripe
customerId: window.localStorage.getItem("customerId"),
// Ainsi que le promotionCode
promotionCode: window.localStorage.getItem("promotionCode"),
// et la clé du setupIntent
setupIntentId: setupIntent,
}),
})
.then((res) => res.json())
// Une fois les mensualités mise en place, on peut créer une souscriptions en BDD
.then(() => createSouscription());
window.localStorage.removeItem("promotionCode");
setTimeout(() => {
setAnimation(false);
}, 3000);
setStripeMessage("Paiement réussi, merci pour votre confiance !");
break;

case "processing":
setStripeMessage("Paiement en cours");
break;

case "requires_payment_method":
// Redirect your user back to your payment page to attempt collecting
// payment again
setStripeMessage(
"Failed to process payment details. Please try another payment method."
);
break;
}
});
}, [stripe]);

return (
<>
{stripeMessage &&
<div id="modalBg">
<div id="modalBox">
<div className="paiement-ok">
<img src={successPayment} alt={"Paiement réussi"}/>
<h1>{stripeMessage}</h1>
<h2>
Vous pouvez dès à présent contacter votre Care Manager et
vous allez recevoir votre facture par email dans quelques
instants.
</h2>
{animation && (
<div className="animation">
<img src={cotillon} alt={"animation paiement réussi"}/>
</div>
)}
</div>
<button
className="submit-modal"
onClick={() => history.push("/conversation")}
>
Prendre rendez-vous avec votre Care Manager
</button>
</div>
</div>
}
</>
);
};

StripePaymentModal.propTypes = {
stripeMessage: PropTypes.string,
setStripeMessage: PropTypes.func
};

export default StripePaymentModal;